import { createSelector } from '@ngrx/store';
import { AppFeatures, IAppState } from '../app.state';
import { IUsersState } from './users.state';
import { getTeams, isUserInItTeam } from "../teams/teams.selectors";
export const getUsersState = (state: IAppState) => state[AppFeatures.USERS];
export const getUsersForClientFilterState = (state: IAppState) => state[AppFeatures.USERS_FOR_CLIENT_FILTER];
export const getTeamsState = (state: IAppState) => state[AppFeatures.TEAMS];
export const getUsers = createSelector(getUsersState, (state: IUsersState) => state.users);
export const getUsersForClientFilter = createSelector(getUsersForClientFilterState, (state: IUsersState) => state.users);
export const getUserById = (userId: string) => createSelector(getUsersState, (state: IUsersState) =>
  state?.users?.find(u => u.user_id === userId));
export const getLoggedUser = createSelector(getUsersState, (state: IUsersState) => state.loggedUser);
export const getLoggedUserId = createSelector(getLoggedUser, (user) => user?.user_id);
export const getUsersThatCanSolveAllTickets = createSelector(getUsers, (users) => {
  return users?.filter(user => user?.canSolveTicket === "true");
});
export const getItUsers = createSelector(getUsersState, (state: IUsersState) => {
  return state.users?.filter(user => isUserInItTeam(user?.id))
});
export const getUsersWithTeams = createSelector(getUsers, getTeams, (users, teams) => {
  return users
    ?.filter(user => user?.user_in_filter === '1')
    ?.map(user => {
      return {
        location: user?.location,
        customId: user?.customId,
        user_firstname: user?.user_firstname,
        user_lastname: user?.user_lastname,
        user_id: user?.user_id,
        user_is_active: user?.user_is_active,
        teams: teams
          .filter(team => isUserInTeam(teams, user?.user_id, team?.id))
          .map(team => {
            return {
              id: team?.id,
              lead: team?.lead,
              user_id: user?.user_id,
              team_id: team?.id,
              departament: team?.departament, 
              name: team?.name,
              description: team?.description
            }
        })
      }
    })
});

// get User that are in a team with departament == "JURIDIC"
export const getJuridicUsers = createSelector(getUsersWithTeams, (users) => {
  return users?.filter(user => user?.teams?.some(team => team?.departament === "JURIDIC"))
});

export const isUserInTeam = (teams, userId: string, teamId: string) => {
  return teams?.some(team => 
      team?.members?.some(member => member.user_id === userId && team?.id === teamId)
  );
};

export const getUsersById = createSelector(getUsers, (users) => {
  let usersById = {};
  users?.forEach(user => {
    usersById[user.user_id] = user;
  })
  return usersById;
})
